import { render, staticRenderFns } from "./Vocational.vue?vue&type=template&id=57f075fa&"
import script from "./Vocational.vue?vue&type=script&lang=js&"
export * from "./Vocational.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports